import Cookies from 'js-cookie';

import { SELECTED_VENDOR_ID_COOKIE } from 'src/common/constants';

export const getIsVendorNotChanged = (vendorId: number) => Number(Cookies.get(SELECTED_VENDOR_ID_COOKIE)) === vendorId;
